import { useScroll, useTransform, motion, useSpring } from "framer-motion";
import { ASSETS } from "@/data/content";

// A robotic rhino that "walks" across the bottom of the page as you scroll,
// with a footstep gait + a ground-contact shadow to sell the walking motion.
const RhinoMascot = () => {
  const { scrollYProgress } = useScroll();
  const smooth = useSpring(scrollYProgress, {
    stiffness: 60,
    damping: 20,
    mass: 0.6,
  });

  // Travel left -> right across the full page scroll.
  const left = useTransform(smooth, [0, 1], ["1%", "84%"]);
  const bottom = useTransform(smooth, [0, 0.5, 1], ["1.5rem", "2.75rem", "1.5rem"]);

  return (
    <motion.div
      data-testid="rhino-mascot"
      aria-hidden="true"
      className="pointer-events-none fixed z-30 hidden md:block"
      style={{ left, bottom }}
    >
      <div className="relative w-[120px] lg:w-[136px]">
        {/* two-beat gait: subtle footfall bob + weight-shift pitch */}
        <motion.div
          animate={{
            y: [0, -2.5, 0, -2.5, 0],
            rotate: [0, -0.8, 0, 0.8, 0],
          }}
          transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
        >
          <img
            src={ASSETS.rhino}
            alt=""
            className="w-full object-contain"
            style={{
              transform: "scaleX(-1)",
              filter: "drop-shadow(0 8px 22px rgba(22,252,251,0.25))",
            }}
          />
        </motion.div>

        {/* ground-contact shadow squashes on each footfall */}
        <motion.div
          className="absolute left-1/2 -translate-x-1/2 -bottom-1 h-2 w-20 rounded-[50%] bg-[#16fcfb]/25 blur-md"
          animate={{
            scaleX: [1, 0.82, 1, 0.82, 1],
            opacity: [0.45, 0.65, 0.45, 0.65, 0.45],
          }}
          transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
        />
      </div>
    </motion.div>
  );
};

export default RhinoMascot;
